const itemAvailabilities = {
  OUT_OF_SEASON: 'OUT_OF_SEASON',
  AVAILABLE: 'AVAILABLE',
  THIRD_PARTY: 'THIRD_PARTY',
};

export default itemAvailabilities;
